<template>
    <div class="logo">
        <router-link :to="{ name: 'home' }" ><img src="@/assets/enea_logo.svg" alt="Logo enea" class="logo__img" /></router-link>
    </div>
</template>
